export const IconFacebook20: {
  name: 'icon_facebook_20-8f96c8f4926d'
} = {
  name: 'icon_facebook_20-8f96c8f4926d'
}
